import React, {useContext} from "react";
import {Card} from "antd";
import {CardProps} from "antd/es/card";
import {PanelGroup, Panel, PanelResizeHandle} from "react-resizable-panels";

import { ImageViewerPanelsSizeContext } from "./ImageViewerPanelsSizeContext";

export function ImageViewerLayout({left, right, center}: {
    left: React.ReactNode;
    center: React.ReactNode;
    right: React.ReactNode;
}) {
    const rightIsHidden = !right;
    const leftIsHidden = !left;

    const ctx = useContext(ImageViewerPanelsSizeContext);

    return (
        <div className="image-viewer" style={{width: "100%", height: "100%"}}>
            <PanelGroup direction="horizontal">
                {leftIsHidden || (
                    <>
                        <Panel
                            id="left-panel"
                            minSize={15}
                            maxSize={60}
                            defaultSize={ctx?.get("image_viewer_left_panel/size", 25) as number}
                            onResize={(size) => {
                                ctx?.setDebounced("image_viewer_left_panel/size", size);
                            }}
                        >
                            <div style={{width: '100%', height: '100%', paddingLeft: '8px'}}>
                                <Dock id="left-dock">
                                    {left}
                                </Dock>
                            </div>
                        </Panel>
                        <PanelResizeHandle className="separator"/>
                    </>
                )}
                <Panel
                    id="center-panel"
                    minSize={25}
                >
                    <Dock id="center-dock">
                        {center}
                    </Dock>
                </Panel>
                {rightIsHidden || (
                    <>
                        <PanelResizeHandle className="separator"/>
                        <Panel
                            id="right-panel"
                            minSize={15}
                            maxSize={60}
                            defaultSize={ctx?.get("image_viewer_right_panel/size", 20) as number}
                            onResize={(size) => {
                                ctx?.setDebounced("image_viewer_right_panel/size", size);
                            }}
                        >
                            <div style={{width: '100%', height: '100%', paddingRight: '8px'}}>
                                <Dock id="right-dock">
                                    {right}
                                </Dock>
                            </div>
                        </Panel>
                    </>
                )}
            </PanelGroup>
        </div>
    );
}

function setPrimaryIf(cond: boolean) {
    return cond ? "first" : "second";
}

function hideIf(cond: boolean) {
    return {display: cond ? 'none' : 'initial'}
}

interface DockProps {
    id: string
    children: React.ReactNode
}

function Dock({id, children}: DockProps) {
    if (!children) return null;
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                // border: "1px solid black"
            }}
        >
            <div id={id} style={{width: '100%', height: '100%', paddingBottom: '8px', paddingTop: '8px'}}>
                <DockCard>
                    {children}
                </DockCard>
            </div>
        </div>
    );
}

function DockCard({children, ...props}: CardProps) {
    return (
        <Card
            {...props}
            headStyle={{
                overflow: "auto"
            }}
            style={{
                borderRadius: "4px",

                height: "100%",
                maxHeight: "100%",

                display: 'flex',
                flexDirection: 'column',

                boxShadow: "0px 8px 10px 0px rgba(208, 216, 243, 0.6)",
                ...props.style
            }}
            bodyStyle={{
                padding: "12px",
                // @ts-ignore
                flexGrow: "1",
                overflow: "hidden",
            }}
        >
            {children}
        </Card>
    );
}
